import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';

const NextStepsStyle = styled('div')`
    .box-step {
        ${typography.bodyXs}
        color: var(--sand-700);
        .step-num {
            min-width: 40px;
            width: 40px;
            height: 40px;
            background: var(--orange-300);
            color: var(--sand-100);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
            font-weight: 700;
            letter-spacing: -0.03em;
            margin-bottom: 24px;
        }
        .step-title {
            ${typography.bodyL}
            margin-bottom: 3px;
        }
        .link {
            ${typography.linkMd}
            color: var(--blue-400);
            cursor: pointer;
        }
    }
    
    @media screen and (min-width: 1200px) {
        .box-step {
            max-width: 270px;
        }
    }

    @media screen and (max-width: 767px) {
        .box-step {
            display: flex;
            gap: 16px;
            .step-num {
                margin-bottom: 0px;
            }
        }
    }
`;
export default NextStepsStyle;
